import { Alert } from 'foundations-components/transitional/components/Alert';
import I18n from 'I18n';
import { connect } from 'react-redux';
import { getIsSmsRateLimitAlertVisible } from '../../selectors/TwoFactorAuth';
import { jsx as _jsx } from "react/jsx-runtime";
const SmsRateLimitAlert = ({
  isSmsRateLimitAlertVisible
}) => {
  if (!isSmsRateLimitAlertVisible) {
    return /*#__PURE__*/_jsx("div", {});
  }
  return /*#__PURE__*/_jsx(Alert, {
    type: "danger",
    titleText: I18n.text('login.twoFactor.errors.smsRateLimit.title'),
    children: I18n.text('login.twoFactor.errors.smsRateLimit.body')
  });
};
const mapStateToProps = state => ({
  isSmsRateLimitAlertVisible: getIsSmsRateLimitAlertVisible(state)
});
export default connect(mapStateToProps)(SmsRateLimitAlert);